import React from 'react';
import { IconProps } from './types';

const CheckO: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M12 2C6.48605 2 2 6.48605 2 12C2 17.5139 6.48605 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48605 17.5139 2 12 2ZM17.5429 9.96259L11.1563 16.3492C10.9619 16.5436 10.6925 16.6551 10.4177 16.6551V17.0876L10.4084 16.6551C10.1299 16.6528 9.85946 16.5364 9.66616 16.336L6.44411 12.9963C6.04411 12.5818 6.056 11.9196 6.47049 11.5196C6.66616 11.3306 6.92368 11.2268 7.19546 11.2268C7.48151 11.2268 7.74854 11.3401 7.94724 11.5459L10.4311 14.1204L16.0662 8.48562C16.2634 8.28843 16.5256 8.17968 16.8048 8.17968C17.0837 8.17968 17.3459 8.28822 17.5431 8.48541C17.9501 8.89276 17.9501 9.55546 17.5429 9.96259Z"
    />
  </svg>
);

export default CheckO;
